import { o as e, c as t, a as o } from "./core.0767a1be.js";
const s = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024"
}, r = /* @__PURE__ */ o("path", {
  fill: "currentColor",
  d: "M512 1024C229.248 1024 0 794.752 0 512S229.248 0 512 0s512 229.248 512 512-229.248 512-512 512zm0-938.667C276.352 85.333 85.333 276.352 85.333 512S276.352 938.667 512 938.667 938.667 747.648 938.667 512A426.667 426.667 0 0 0 512 85.333zM512 768a42.667 42.667 0 0 1-42.368-42.667V469.76a42.368 42.368 0 1 1 84.693 0v255.573A42.41 42.41 0 0 1 512 768zm0-426.667a42.325 42.325 0 1 1-.085-84.65 42.325 42.325 0 0 1 .085 84.65zm42.325-42.666z"
}, null, -1), a = [
  r
];
function c(n, l) {
  return e(), t("svg", s, a);
}
const i = { render: c };
export {
  i as default,
  c as render
};
//# sourceMappingURL=tip.f5226685.js.map
